const API_BASE_URL = window.location.hostname === 'localhost' ? 'http://localhost:5001/api' : 'https://best-foliday-p9m7.onrender.com/api';
export default API_BASE_URL;
